/* eslint-disable @typescript-eslint/no-explicit-any */
import { useState } from "react";
import { enqueueSnackbar } from "notistack";
import { useQueryClient } from "@tanstack/react-query";

import AppModal from "../feedBacks/AppModal";
import { CARD_TITLE } from "../../utils/constants";
import { ButtonType } from "../../enums/componentEnums";
import AppButton from "../Inputs/AppButton";
import { usePostData } from "../../customHooks/usePostData";
import { deleteIcon } from "../../assets/layout";
import { CiWarning } from "react-icons/ci";
import { IconWrapper } from "../../customHooks/useIcon";
function DeleteConfirmationModal({
  isModalOpen,
  closeModal,
  enableOutsideClick = true,
  title = "Confirm Deletion",
  instruction = "Are you sure you want to delete this item?",
  route,
  invalidateQueryKey,
  successMessage = "Item deleted successfully!",
  errorMessage = "Error deleting item",
  itemId,
}: {
  isModalOpen: boolean;
  closeModal: () => void;
  enableOutsideClick?: boolean;
  title?: string;
  instruction?: string;
  route: string;
  invalidateQueryKey: unknown[];
  successMessage?: string;
  errorMessage?: string;
  itemId: string | number;
}) {
  const queryClient = useQueryClient();
  const [isDeleting, setIsDeleting] = useState(false);

  const { mutate } = usePostData(route, "DELETE", {
    onSuccess: () => {
      // Invalidate queries to refresh data
      queryClient.invalidateQueries({
        queryKey: invalidateQueryKey,
      });

      enqueueSnackbar(successMessage, {
        variant: "success",
      });
      setIsDeleting(false);
      closeModal();
    },
    onError: (err) => {
      const errorMessages = Object.values(err.response?.data || {})
        .flat()
        .join(" ");
      enqueueSnackbar(errorMessages || errorMessage, {
        variant: "error",
      });
      setIsDeleting(false);
    },
  });

  const handleDelete = () => {
    setIsDeleting(true);
    mutate({id: itemId});
  };

  return (
    <AppModal
      isOpen={isModalOpen}
      onClose={closeModal}
      closeOnOutsideClick={enableOutsideClick}
    >
      <div className="w-full-h-full flex flex-col items-center justify-center">
        <img src={deleteIcon} alt="Delete icon" className="max-h-[150px]" />
        <h2 className={`${CARD_TITLE} self-center`}>{title}</h2>

        <div className="text-gray-700 bg-[#ffe9d9] p-4 gap-2 border-l-4 border-primary-redMain rounded-md w-full min-h-[70px] flex flex-col items-start justify-center">
          <p className=" text-primary-redMain flex items-center font-bold">
            <IconWrapper icon={CiWarning} className="font-bold " size={22} />
            Warning
          </p>
          <p className="font-semibold">{instruction}</p>
        </div>

        <div className="flex gap-4 justify-center w-full mt-6">
          <AppButton
            className="w-32"
            text={isDeleting ? "" : "Delete"}
            loader={{ loading: isDeleting, height: 4, width: 4 }}
            type={ButtonType.DELETE}
            handleClick={handleDelete}
            disabled={isDeleting}
          />
          <AppButton
            className="w-32"
            text="Cancel"
            type={ButtonType.SECONDARY}
            handleClick={closeModal}
            disabled={isDeleting}
          />
        </div>
      </div>
    </AppModal>
  );
}

export default DeleteConfirmationModal;
